var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import NumberInputCss from "./NumberInputCss.js";
import "../Popup/Popup.js";
class NumberInput extends s {
  constructor() {
    super();
    __publicField(this, "validate", () => {
      if (this.readonly) {
        return true;
      }
      const input = this.shadowRoot.querySelector("input");
      let valid = input.checkValidity();
      const validity = input.validity;
      if (valid || validity.stepMismatch) {
        if (!this._checkMaxDigits()) {
          valid = false;
          this.classList.add("error");
          const translationKey = this.maximumFractionDigits === 0 ? "integer" : "maxDigits";
          this.message = translateText(this._translations(), translationKey, this.maximumFractionDigits);
        } else if (this.value < this.min) {
          this.classList.add("error");
          this.message = translateText(this._translations(), "min", this.min);
        } else if (this.value > this.max) {
          this.classList.add("error");
          this.message = translateText(this._translations(), "max", this.max);
        } else {
          valid = true;
          this.classList.remove("error");
          this.message = "";
        }
      } else {
        this.classList.add("error");
        this.message = translateText(this._translations(), "empty");
      }
      this.requestUpdate();
      return valid;
    });
    __publicField(this, "getValue", () => isEmpty(this.value) ? this.value : parseFloat(this.value));
    __publicField(this, "hasChanges", () => this.valueChanged);
    this.message = "";
    this.valueChanged = false;
  }
  static get styles() {
    return [NumberInputCss];
  }
  static get properties() {
    return {
      label: { type: String },
      helpText: { attribute: "help-text", type: String | Function },
      value: { type: String },
      placeholder: { type: String },
      placeholderEmpty: { attribute: "placeholder-empty", type: String },
      min: { type: Number },
      max: { type: Number },
      step: { type: String },
      maximumFractionDigits: { attribute: "maximum-fraction-digits", type: Number },
      inline: { type: Boolean },
      disabled: { type: Boolean },
      required: { type: Boolean },
      readonly: { type: Boolean },
      title: { type: String }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.numberFormat = new Intl.NumberFormat("de-ch", { maximumFractionDigits: this.maximumFractionDigits });
  }
  updated(changedProperties) {
    let updatedProperties = changedProperties.has("max") || changedProperties.has("min") || changedProperties.has("maximumFractionDigits");
    updatedProperties = updatedProperties || changedProperties.has("required") || changedProperties.has("value");
    const shouldCheck = this.valueChanged || !!this.value;
    if (shouldCheck && updatedProperties) {
      this.requestUpdate();
      this.updateComplete.then((_) => this.validate());
    }
  }
  render() {
    return this.readonly ? this.renderReadonly() : this.renderComponent();
  }
  renderComponent() {
    var _a;
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="${this.inline ? "inline" : ""}">
        <div class="label-wrapper">
          <label for="isceco-number-input">
            ${this.label}
          </label>
          ${this.renderInfo()}
        </div>
        <input id="isceco-number-input"
               type="text"
               title="${(_a = this.title) != null ? _a : " "}"
               value="${isEmpty(this.value) ? "" : this.value}"
               placeholder="${this.placeholder}"
               min="${this.min}"
               max="${this.max}"
               step="${this.step}"
               ?disabled="${this.disabled}"
               ?required="${this.required}"
               @change="${(e) => this._change(e)}"
               @keydown="${(e) => this._keydown(e)}"
               @keyup="${(e) => this._keyup(e)}"
        />
      </div>
      <p id="message">
        <i class="exclamation triangle icon"></i>
        ${this.message}
      </p>
    `;
  }
  renderReadonly() {
    let value = "";
    if (!isEmpty(this.value)) {
      value = this.value;
    } else if (!isEmpty(this.placeholderEmpty)) {
      value = this.placeholderEmpty;
    }
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="readonly ${this.inline ? "inline" : ""}">
        <div class="label-wrapper">
          <span>${this.label}</span>
          ${this.renderInfo()}
        </div>
        <p>
          ${isEmpty(this.value) ? value : this.numberFormat.format(this.value)}
        </p>
      </div>
    `;
  }
  renderInfo() {
    if (isEmpty(this.helpText)) {
      return y``;
    } else {
      const helpText = this.helpText instanceof Function ? this.helpText() : this.helpText;
      return y`
        <isceco-popup direction="right">
          <i slot="wrapper" class="info circle icon"></i>
          <div slot="content">${helpText}</div>
        </isceco-popup>
      `;
    }
  }
  _change(event) {
    event.stopPropagation();
    this.value = this._cleanupValue(event.target.value);
    this.valueChanged = true;
    const valid = this.validate();
    send("change", { valid, value: this.value }, this);
    event.target.value = this.value;
  }
  _keydown(event) {
    var _a;
    const step = (_a = this.step) != null ? _a : 1;
    let tmpValue = parseFloat(this.value);
    switch (event.code) {
      case "ArrowUp":
        tmpValue += step;
        if (this.max !== void 0 && tmpValue > this.max) {
          tmpValue = this.max;
        }
        break;
      case "ArrowDown":
        tmpValue -= step;
        if (this.min !== void 0 && tmpValue < this.min) {
          tmpValue = this.min;
        }
        break;
      default:
        return;
    }
    event.preventDefault();
    if (isEmpty(this.value)) {
      this.value = this.min.toString();
    } else {
      this.value = tmpValue.toString();
    }
    this.valueChanged = true;
    const valid = this.validate();
    send("change", { valid, value: this.value }, this);
  }
  _keyup(event) {
    event.stopPropagation();
    event.preventDefault();
    if (["Tab", "Shift"].includes(event.key)) {
      return;
    }
    this.value = this._cleanupValue(event.target.value);
    const valid = this.validate();
    send("keyup", { valid, value: this.value }, this);
  }
  _cleanupValue(value) {
    const numberValue = parseFloat(value);
    return isNaN(numberValue) || isEmpty(numberValue) ? "" : numberValue.toString();
  }
  _checkMaxDigits() {
    if (this.maximumFractionDigits === void 0 || isEmpty(this.value)) {
      return true;
    }
    const dotIndex = this.value.indexOf(".");
    const digits = dotIndex > -1 ? this.value.length - dotIndex - 1 : 0;
    return digits <= this.maximumFractionDigits;
  }
  _translations() {
    return {
      de: {
        empty: "Wert darf nicht leer gelassen werden.",
        integer: "Nur die Eingabe ganzer Zahlen ist erlaubt",
        maxDigits: (max) => `Nur Zahlen mit maximal ${max} Dezimalstellen sind erlaubt.`,
        min: (min) => `Wert darf nicht kleiner sein als ${min}.`,
        max: (max) => `Wert darf nicht gr\xF6sser sein als ${max}.`
      },
      fr: {
        empty: "La valeur ne doit pas \xEAtre laiss\xE9e vide.",
        integer: "Seule la saisie de nombres entiers est possible.",
        maxDigits: (max) => `Seuls les chiffres avec un maximum de ${max} d\xE9cimales sont autoris\xE9s.`,
        min: (min) => `La valeur ne doit pas \xEAtre moins grande que ${min}.`,
        max: (max) => `La valeur ne doit pas \xEAtre plus grande que ${max}.`
      },
      it: {
        empty: "Il valore non deve essere lasciato vuoto.",
        integer: "\xC8 possibile inserire solo numeri interi.",
        maxDigits: (max) => `Sono ammessi solo numeri con un massimo di ${max} cifre decimali.`,
        min: (min) => `Il valore non deve essere inferiore a ${min}.`,
        max: (max) => `Il valore non deve essere maggiore di ${max}.`
      },
      en: {
        empty: "Value must not be left empty.",
        integer: "Only whole numbers are allowed.",
        maxDigits: (max) => `Only numbers with a maximum of ${max} decimal places are allowed.`,
        min: (min) => `Value must not be less than ${min}.`,
        max: (max) => `Value must not be greater than ${max}.`
      }
    };
  }
}
customElements.define("isceco-number-input", NumberInput);
export { NumberInput as default };
